import * as mac from "@/data/api/mac"
import config from "@/config"
import {getTestData} from "@/data/repos/mockDataLoader"

export async function executeQuery(
  database: string, queryName: string, args: object,
  filter?: (x: any) => any,
  offset?: number, limit?: number): Promise<any[]> {
  if (process.env.NODE_ENV === "test") {
    return getTestData(queryName)
  }
  try {
    const r = await mac.api.post("query?name=" + encodeURIComponent(queryName), {
      queryName,
      database,
      args,
      offset,
      limit,
    })
    if (!r) {
      console.error("executeQuery failed", "database:", database, "queryName:", queryName, "args:", args, "error:", r)
      return []
    }
    try {
      return filter ? filter(r.data) : r.data
    } catch (err) {
      console.error("Data filter failed in executeQuery:", err)
      return []
    }
  } catch (err) {
    console.error("executeQuery failed", "database:", database, "queryName:", queryName, "args:", args, "error:", err)
    return []
  }
}

export function buildQueryDownloadUrl(db: string, q: string, args: object, fmt = "csv"): string {
  return `${config.BASE_API_URL}queryDownload?${map2querystring(new Map(Object.entries({db, q, fmt, ...args})))}`
}

function map2querystring(data: Map<string, any>): string {
  return encodeURI([...data.entries()].map((v) => v[0] + "=" + v[1]).join("&"))
}
